import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./VerifyEmailPage.css";

const logo = "/logo192.png";

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [pendingAccountExists, setPendingAccountExists] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [err, setErr] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const navi = useNavigate();

  const normalizeErr = (data) => {
    if (!data) return "Bad Request";
    if (typeof data === "string") return data;
    if (data.message) return data.message;

    try {
      return JSON.stringify(data);
    } catch {
      return "Bad Request";
    }
  };

  const handleVerify = async () => {
    setIsLoading(true);
    setErr("");

    try {
      const response = await axios.post(
        `${ApiConnectionString}/api/user/${token}`
      );

      if (response.status === 200) {
        setEmailVerified(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErr(normalizeErr(error.response.data));
      } else {
        setErr("An unexpected error occurred.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(
          `${ApiConnectionString}/api/PendingAppUser/${token}`
        );

        if (response.status === 200) {
          setPendingAccountExists(response.data);
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          setErr(normalizeErr(error.response.data));
        } else {
          setErr("An unexpected error occurred.");
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (token) {
      getData();
    } else {
      setErr("Verification token is missing.");
      setIsLoading(false);
    }
  }, [token]);

  if (isLoading) {
    return (
      <div className="verify-loading">
        <LoadingSpinner />
      </div>
    );
  }

  if (emailVerified) {
    return (
      <div className="verify-page">
        <div className="verify-card">
          <div className="verify-brand">
            <div className="verify-logo">
              <img src={logo} alt="Therapy Diary logo" />
            </div>

            <div>
              <h1>Therapy Diary</h1>
            </div>
          </div>

          <div className="verify-icon success">✓</div>

          <div className="verify-heading">
            <h2>Email verified</h2>
            <p>Your email address has been verified. You can now log in.</p>
          </div>

          <button
            className="btn verify-btn w-100"
            onClick={() => navi("/login")}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="verify-page">
      <div className="verify-card">
        <div className="verify-brand">
          <div className="verify-logo">
            <img src={logo} alt="Therapy Diary logo" />
          </div>

          <div>
            <h1>Therapy Diary</h1>
          </div>
        </div>

        {err && (
          <div className="alert alert-danger text-start" role="alert">
            <p className="mb-2">{err}</p>
            <Link to="/register" className="alert-link">
              Create a new account
            </Link>
          </div>
        )}

        {pendingAccountExists ? (
          <>
            <div className="verify-icon pending">✉</div>

            <div className="verify-heading">
              <h2>Verify your email</h2>
              <p>Click the button below to complete your account setup.</p>
            </div>

            <button
              onClick={handleVerify}
              className="btn verify-btn w-100"
            >
              Verify email
            </button>
          </>
        ) : (
          !err && (
            <>
              <div className="verify-icon failed">!</div>

              <div className="verify-heading">
                <h2>No pending account found</h2>
                <p>
                  This verification link may have expired or already been used.
                </p>
              </div>

              <Link to="/register" className="btn verify-btn w-100">
                Create account
              </Link>
            </>
          )
        )}
      </div>
    </div>
  );
}